import { render } from "./FriendAssignItem.vue?vue&type=template&id=0481a186"
import script from "./FriendAssignItem.vue?vue&type=script&lang=js"
export * from "./FriendAssignItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__